const hostname = window.location.hostname;
const isLocal = hostname === "localhost" || hostname.startsWith("192.168.") || hostname.startsWith("10.") || hostname.startsWith("172.");

const BASE = isLocal ? `http://${hostname === "localhost" ? "localhost" : hostname}:8081` : "https://api.spcheapcars.ro";

export const API_URL = BASE;
export const UPLOADS_URL = `${BASE}/uploads`;

export const generateSlug = (masina) =>
    `${masina.marca}-${masina.model}-${masina.an}`
        .toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
